export const KANA_REGEX = /^[ァ-・ヽヾ゛゜ー]+$/g
export const POSTAL_NUMBER_REGEX = /^\d{3}\d{4}$/
export const EMAIL_REGEX = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/gm
export const PHONE_REGEX = /^0\d{9,10}$/
export const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-zA-Z])(.+){8,100}$/
export const OTP_REGEX = /^\d{6}$/
